<template>
<div style="display:none;">social login</div>
</template>

<script>
  import {SOCIAL_AUTH_REQUEST, USER_REQUEST} from '../store/actions/userConst'
  import { mapGetters} from 'vuex';
  export default {
    created() {
      this.$store.dispatch(SOCIAL_AUTH_REQUEST, this.access_token)
              .then(resp => {
                console.log(resp)
                this.$store.dispatch(USER_REQUEST)
                .then((resp)=> {
                    console.log(resp)
                    if (!this.getUserProfile.isAgreementAccepted) {
                      this.$router.push({name: 'profile', params: {id: this.getUserProfile.id}})
                    } else {
                      this.$router.push({name: 'search'})
                    }
                })
                .catch((err)=>console.log(err))
              })
              .catch(err => {
                console.log(err)
              });
    },
    props: {
      access_token: {type: String, default: null}
    },
    computed: {
        ...mapGetters(['getUserProfile']),
    },
  }
</script>
